import { QuestionnaireOptions } from '../../hooks/useQuestionnaireQuery';
import { getDefaultEndDate, getDefaultStartDate, lastDayOfLastMonth } from '../../utils/dateUtils';
import { endOfMonth } from 'date-fns';

/**
 * @french
 * État initial du slice des exercices.
 */
export const questionnaireInitialState = {
  questionnaireEnabled: false,
  loading: false,
  fileId: undefined as string | undefined,
  questionnaireId: undefined as string | undefined,
  questionnaireOptions: {
    categoryIds: [] as string[],
    testIsCollab: false,
    exclureAn: false,
    dateDebutExercice: getDefaultStartDate(),
    dateFinExercice: getDefaultEndDate(getDefaultStartDate()),
    dateRef: endOfMonth(lastDayOfLastMonth()),
    delaiAchat: 0,
    delaiVente: 30,
  } as QuestionnaireOptions,
  fetchNew: false,
  pdfModalVisible: false,
  downloading: false,
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type QuestionnaireState = typeof questionnaireInitialState;
